import { render, staticRenderFns } from "./RsaPaiInteventiProgrammatiEditComponent.vue?vue&type=template&id=4158ef8e"
import script from "./RsaPaiInteventiProgrammatiEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaPaiInteventiProgrammatiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports